import { IApiResponse } from "../../../@types/api-response.type";
import { IGrid } from "../../../@types/grid.type";
import { IInviteNewUser } from "../../../@types/invite-new-user.type";
import { IUserFilter } from "../../../@types/user-filter.type";
import { IUserInformation } from "../../../@types/user-information.type";
import { IUser, IUserRequest } from "../../../@types/user.type";
import { Api } from "../ApiConfig";
import { ApiException } from "../ApiException";
import { getErrorMessage } from "../../../utils/utils";

export const ensureUser = async (userInformation: IUserInformation): Promise<IUserInformation> => {
  try {
    const { data } = await Api.post<IApiResponse<IUserInformation>>(`/api/User/EnsureUser`, userInformation);
    return data.result;

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar informações do usuário'))
  }
}

export const getAllUsersByGroupId = async (id: string) => {

  try {
    const { data } = await Api.get(`/api/User/GetAllUsers?groupId=${id}`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar os membros do grupo'))
  }
}

export const getAllUsers = async () => {

  try {
    const { data } = await Api.get(`/api/User/GetAllUsers`)
    return data

  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os membros disponíveis'))
  }
}

export const searchUsers = async (userFilter: IUserFilter): Promise<IGrid<IUser> | ApiException> => {
  try {
    const response = await Api.post<IApiResponse<IGrid<IUser>>>(`api/User/SearchUsers`, userFilter)
    return response.data.result
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar todos os Usuários'))
  }
}

export const getUserById = async (id: string) => {
  try {
    const { data } = await Api.get(`api/User/GetUserById?id=${id}`)
    return data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao buscar User'))
  }

}

export const addOrUpdateUser = async (userDto: IUserRequest) => {
  try {
    const { data } = await Api.post(`api/User/AddOrUpdateUser`, userDto)
    return data
  } catch (error) {
    const message = 'Erro ao criar ou atualizar Usuário';
    throw new ApiException(getErrorMessage(error, message));
  }
}

export const deleteUser = async (userId: string) => {
  try {
    const { data } = await Api.delete(`api/User/DeleteUser/${userId}`)
    return data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar User'))
  }

}

export const removeUserFromGroup = async (userId: string, groupId: string) => {

  try {
    await Api.post(`/api/User/removeUserFromGroup`, { "userId": userId, "groupId": groupId });
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao deletar o membro do grupo'))
  }
}

export const addUserToGroup = async (userId: string, groupId: string) => {

  try {
    const { data } = await Api.post(`/api/User/addUserToGroup`,
      {
        "userId": userId,
        "groupId": groupId
      });
    return data;
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao adicionar o membro no grupo'))
  }
}

export const inviteNewMemberToGroup = async (data: IInviteNewUser) => {
  try {
    const response = await Api.post(`/api/User/InviteNewMemberToGroup`,
      {
        "email": data.email,
        "firstname": data.firstname,
        "lastname": data.lastname
      });
    return response.data
  } catch (error) {
    throw new ApiException(getErrorMessage(error, 'Erro ao enviar email'))
  }
}

